// Case Attribute
export enum EKwikUIInputCase {
  DEFAULT = "default",
  UPPER = "upper",
  LOWER = "lower"
}
export const VKwikUIInputCase = [
  EKwikUIInputCase.DEFAULT,
  EKwikUIInputCase.UPPER,
  EKwikUIInputCase.LOWER
] as const;

export type TKwikUIInputCase = (typeof VKwikUIInputCase)[number];

// Type Attribute
export enum EKwikUIInputType {
  TEXT = "text",
  EMAIL = "email"
}
export const VKwikUIInputType = [
  EKwikUIInputType.TEXT,
  EKwikUIInputType.EMAIL
] as const;

export type TKwikUIInputType = (typeof VKwikUIInputType)[number];

// Size Attribute
export enum EKwikUIInputSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputSize = [
  EKwikUIInputSize.S,
  EKwikUIInputSize.M,
  EKwikUIInputSize.L
] as const;

export type TKwikUIInputSize = (typeof VKwikUIInputSize)[number];
